export default {
	"lang": "en",
	"page-title": "تحليل السوق",
}